import { VuexContext } from "@mv/flow-shared-utils/types/vuex";
import { handleErrors } from "@/utils/handle-errors";
import { ISdkLoginCredentials, JwtActions } from "@/interfaces/sdk-login";
import { getCookie } from "@/utils/cookie";
import { setTokenInfo } from "./types";

const jwt = require("jsonwebtoken") as JwtActions;

export const loadLogin = (login: ISdkLoginCredentials, environmentId: number) => ({ type: "loadLogin", login, environmentId });
export const validateCredentials = (login: ISdkLoginCredentials) => ({ type: "validateCredentials", login });
export const parseAccessToken = () => ({ type: "parseAccessToken" });

export const actions = {
  loadLogin(state: any, { login, environmentId }: { login: ISdkLoginCredentials; environmentId: number }) {
    return fetch(`core/api/login/${environmentId}`, {
      method: "POST",
      body: JSON.stringify(login),
      headers: { "content-type": "application/json" },
    })
      .then(handleErrors)
      .then((data) => data);
  },

  validateCredentials(state: any, { login }: { login: ISdkLoginCredentials }) {
    return fetch(`core/api/validate-credentials`, {
      method: "POST",
      body: JSON.stringify(login),
      headers: { "content-type": "application/json" },
    })
      .then(handleErrors)
      .then((res) => {
        return { companies: res, valid: true };
      })
      .catch((err) => {
        throw err;
      });
  },

  parseAccessToken(context: VuexContext) {
    const token = getCookie("access_token");
    const parsedToken = jwt.decode(token);
    context.commit(setTokenInfo, parsedToken);
  },
};
